var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff97cb;}.cls-3{fill:#ffeefa;}.cls-4{fill:#ffdcf3;}.cls-5{fill:#ffd4f2;}.cls-6{fill:#ffccf2;}.cls-7{fill:#ffc5f3;}.cls-8{fill:#ffbdf3;}.cls-9{fill:#ffb0db;}.cls-10{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-rpm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.37,118.35a64.71,64.71,0,0,1-6.73,26.7L166,141.27a56.2,56.2,0,0,0,5.82-22.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.7,118.7A64.56,64.56,0,0,0,56.42,145L64,141.27a56,56,0,0,1-5.84-22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.52,89.91a56.53,56.53,0,0,0-6.3,23.3H49.71a64.9,64.9,0,0,1,7.42-27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.31,68.2A57.33,57.33,0,0,0,67,85.58l-7.2-4.52A65.7,65.7,0,0,1,80,60.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.17,59.24a56.49,56.49,0,0,0-23.42,6.37l-4.43-7.27a64.92,64.92,0,0,1,28.23-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.31,65.61a56.5,56.5,0,0,0-24-6.39l.17-8.51a65,65,0,0,1,27.88,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M162.77,85.16A57.32,57.32,0,0,0,145.37,68l4.46-7.24a65.85,65.85,0,0,1,20.41,20.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M171.83,113.21a56.55,56.55,0,0,0-6.44-23.58l7.42-4.16a65,65,0,0,1,7.54,27.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.67,144.26a13.31,13.31,0,0,1,.76,4.14,13.09,13.09,0,1,1-23-8.24l9.07-32.37,10.44,32A13.12,13.12,0,0,1,129.67,144.26Zm-19.11,6.83a7.21,7.21,0,0,0,6.93,4.78,7.19,7.19,0,0,0,4.8-12.41l-.54-.51-4.85-14.84-4.21,15-.52.54a7.22,7.22,0,0,0-1.61,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M131.83,98H97.52a5.17,5.17,0,0,1-5.17-5.16v-7a5.17,5.17,0,0,1,5.17-5.16h34.31A5.17,5.17,0,0,1,137,85.84v7A5.17,5.17,0,0,1,131.83,98Zm-33.58-5.9h32.84V86.58H98.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRpm);
export default __webpack_public_path__ + "static/media/ic-rpm.0343bd7f559878ba41d88f3df0b89800.svg";
export { ForwardRef as ReactComponent };